module.exports = __webpack_public_path__ + "static/media/access-to-care.09fc8b42.svg";